import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import ColorPalette from './ColorPalette';
import { useState } from 'react';
import { saveCanvasState } from '../../Actions/Rutab/HistoryActions';
import { debounce } from 'lodash-es';
export const BackgroundMenuContent = ({ canvas }) => {
    const [backgroundColor, setBackgroundColor] = useState(canvas.backgroundColor);
    const dispatch = useDispatch();
    const debouncedColorChange = debounce((color) => {
        dispatch(saveCanvasState(canvas));
        setBackgroundColor(color);
    }, 300);
    const ChangeCanvasBackgroundColor = (color) => {
        canvas.set({ backgroundColor: color });
        canvas.renderAll();
        debouncedColorChange(color);
    };
    return (_jsx("div", { className: 'background-selector-content-guide', children: _jsx(ColorPalette, { selectedColor: canvas.backgroundColor, onColorChange: ChangeCanvasBackgroundColor }) }));
};
